require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./articles-what-documentation-will-i-need-to-open-a-business-account.json") })
        }
      }, "path---articles-what-documentation-will-i-need-to-open-a-business-account");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---articles-what-documentation-will-i-need-to-open-a-business-account!./.cache/json/articles-what-documentation-will-i-need-to-open-a-business-account.json
// module id = 1970
// module chunks = 231608221292675